export const AppConstants = {
  //   USER_MANAGEMENT_BASE_URL: "https://devapi.spotfinder.app/user-management/api",
  //   SPOT_FINDER_BASE_URL: "https://devapi.spotfinder.app/roadtotravel/api",
  //   GOOGLE_MAPS_API_KEY: "AIzaSyDOdvhIcQ-5mf9w1qKIp3lTpF5LO4OWpqQ",
  //   STRIPE_PUBLISHABLE_KEY:
  //     'pk_test_51L5pObSDcInk1La4gAldPDM4Z1zxmNeGBMsfiaWintlCHbCGcMNudbfEKoXi5PkyhmJkY1jucYvw6QlZiBNJKg1B005ErUWzmR',
  GOOGLE_OAUTH_CLIENT_ID:
    "64757640257-s3hqq2ts5d9td573ufr26mlr74u3fe00.apps.googleusercontent.com",
};
// GOOGLE_OAUTH_CLIENT_ID:'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'
export enum REGEX_CONSTANT {
  ONLY_NUMBER = "^[0-9]*$",
  ONLY_ALPHABETWITHSPACE = "^[a-zA-Z ]*$",
  ONLY_ALPHABET = "^[a-zA-Z]*$",
  ONLY_ALPHANUMERIC = "^[a-zA-Z0-9]*$",
  EMAIL = "^[\\w!#$%&’*+/=?`{|}~^-]+(?:.[\\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$",
  VEHICAL_NUMBER ='^[A-zA-Z]{2}[0-9]{2}?[a-zA-Z]{1,2}?[0-9]{4}$',
 
  
}
